import { useMemo } from 'react';

import { useJoinCustomRoom } from 'App/components/WebSocket';

import { useParams } from '@gogame/screens';

import { EVENT_JOIN_MP, EVENT_LEAVE_MP } from '../constants';

export const useSocketRoom = () => {
  const { year, month, version } = useParams();

  const params = useMemo(() => {
    return { year, month, version };
  }, [year, month, version]);

  useJoinCustomRoom({
    joinEvent: EVENT_JOIN_MP,
    leaveEvent: EVENT_LEAVE_MP,
    params: params,
  });
};
